import {
    apiRequest,
    undanganpelantikanCreate,
    undanganpelantikanListPegawai,
    ListJabatan,
    // masterCategories
} from "../../../../../services/adapters/kepegawaian/undanganPelantikanService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", undanganpelantikanCreate, {
            body: query
        }, true)
    }

    fetchPegawai = async (query) => {
        return await apiRequest("get", undanganpelantikanListPegawai, {
            body: query
        }, true)
    }

    fetchPegawai = async (query) => {
        return await apiRequest("get", undanganpelantikanListPegawai, {
            body: query
        }, true)
    }
    fetchListJabatan = async (query) => {
        return await apiRequest("get", ListJabatan, {
            body: query
        }, true)
    }
}

export default CreateRepository